import React from 'react';
import { ClockIcon, UnplugIcon, RefreshCwIcon, ShoppingCartIcon, LayoutDashboardIcon, ZapIcon } from 'lucide-react';
const problems = [{
  icon: ClockIcon,
  text: 'Manual processes slowing down operations'
}, {
  icon: UnplugIcon,
  text: 'Disconnected systems and duplicate data'
}, {
  icon: RefreshCwIcon,
  text: 'Legacy software that needs modernization'
}, {
  icon: ShoppingCartIcon,
  text: 'E-commerce platforms needing custom integrations'
}, {
  icon: LayoutDashboardIcon,
  text: 'Internal dashboards, portals, and business tools'
}, {
  icon: ZapIcon,
  text: 'AI automation for support and repetitive tasks'
}];
export function CommonProblems() {
  return <section className="py-20 bg-background texture-light" data-id="element-297">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-298">
        <div className="text-center mb-12 scroll-fade-in-up" data-id="element-299">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4" data-id="element-300">
            Common Problems We Solve
          </h2>
          <p className="text-lg text-muted max-w-2xl mx-auto" data-id="element-301">
            We help businesses replace manual workflows, connect disconnected
            systems, modernize outdated software, and build custom tools that
            support growth.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto scroll-fade-in-up" data-id="element-302">
          {problems.map(({
          icon: Icon,
          text
        }, i) => <div key={i} className="card-premium border border-border rounded-xl p-6 flex items-start gap-4" data-id="element-303">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20" data-id="element-304">
                <Icon className="w-5 h-5 text-accent" data-id="element-305" />
              </div>
              <p className="text-ink font-medium leading-snug" data-id="element-306">{text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}